import {
	QueryParamConfig,
	UrlUpdateType,
	decodeDelimitedArray,
	encodeDelimitedArray,
	useQueryParam
} from 'use-query-params';
import { CheckboxItem } from 'components/core/checkbox-group';
import { useAppSelector } from 'redux/store';

export const CATEGORY_QUERY_KEY = 'categorien';

type NewValueType<D> = D | ((latestValue: D) => D);

export type UseCategoryReturn = {
	selectedCategories: CheckboxItem[];
	selectedCategoriesParam: string | (string | null)[] | null | undefined;
	setSelectedCategoriesParam: (
		newValue: NewValueType<CheckboxItem[] | null | undefined>,
		updateType?: UrlUpdateType | undefined
	) => void;
};

export const useCategory = (): UseCategoryReturn => {
	const { categories } = useAppSelector((state) => state.wooRequests);

	const [selectedCategoriesParam, setSelectedCategoriesParam] = useQueryParam(CATEGORY_QUERY_KEY, CategoryArrayParam);
	const selectedCategories = categories.filter((category) => selectedCategoriesParam?.includes(category.id.toString()));

	return {
		selectedCategories,
		selectedCategoriesParam,
		setSelectedCategoriesParam
	};
};

export const CategoryArrayParam: QueryParamConfig<
	CheckboxItem[] | null | undefined,
	string | (string | null)[] | null | undefined
> = {
	encode: (array) => {
		if (array == null) {
			return undefined;
		}

		const categories = array.filter(Boolean).map((checkboxItem) => String(checkboxItem.id));
		const value = categories.length > 0 ? categories : null;
		return encodeDelimitedArray(value);
	},
	decode: (param) => {
		return decodeDelimitedArray(param);
	}
};
